export enum PurchaseOrderStatus {
  OPEN = "OPEN",
  APPROVED = "APPROVED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
